/* eslint-disable react/sort-comp,react/jsx-handler-names */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { selectSubmittedOfferUrl } from 'redux/modules/offer';
import * as ObjectUtil from 'helpers/object';
import { withSagas } from 'decorators/Sagas';
import { withInterpolate } from 'decorators/Interpolate/Interpolate';
import { decorateWith, withName } from 'helpers/decorator';
import { VARIABLE_REGEX as DOLLAR_SIGN_REGEX } from 'helpers/interpolate';
import { isEmpty } from 'helpers/verify';
import { AccountCard } from './AccountCard';
import { LeadCard } from './LeadCard';
import { ProductCard, ProductCardUnwrapped } from './ProductCard';
import { ProductForm } from '../forms/ProductForm';
import { redirectToNextStep, watchSignupCardSagas } from '../sagas/signup-card.saga';

const STEPS = {
  ACCOUNT: 'account',
  LEAD: 'lead',
  PRODUCT: 'product',
};

export const TRANSITION_DELAY = 600;

export class SignupCardUnwrapped extends Component {
  constructor(...args) {
    super(...args);
    this.advanceStep = this.advanceStep.bind(this);
    this.clearPreviousStep = this.clearPreviousStep.bind(this);
    this.onComplete = this.onComplete.bind(this);
    this.renderStepAccount = this.renderStepAccount.bind(this);
    this.renderStepLead = this.renderStepLead.bind(this);
    this.renderStepProduct = this.renderStepProduct.bind(this);

    this.state = {
      steps: [STEPS.PRODUCT, STEPS.LEAD, STEPS.ACCOUNT],
      previousStep: null,
    };
  }

  advanceStep(results) {
    const { steps, stepResults } = this.state;
    const [currentStep, ...nextSteps] = steps;

    this.setState({ stepResults: { ...stepResults, ...results } });

    if (isEmpty(nextSteps)) {
      this.onComplete();
    } else {
      this.setState({
        steps: nextSteps,
        previousStep: currentStep,
      });
    }
  }

  clearPreviousStep() {
    this.setState({ previousStep: null });
  }

  hasPreviousStep() {
    return Boolean(this.state.previousStep);
  }

  interpolateVariables(text) {
    // TODO: Write tests for variable interpolation
    const interpolate = this.props.interpolate || (i => i);
    return interpolate(text);
  }

  isCurrentStep(step) {
    return this.state.steps[0] === step;
  }

  isPreviousStep(step) {
    return this.state.previousStep === step;
  }

  onComplete() {
    if (this.props.onComplete) {
      this.props.onComplete();
    }
  }

  renderStep(stepName, stepRenderer) {
    if (this.isPreviousStep(stepName)) {
      setTimeout(this.clearPreviousStep, TRANSITION_DELAY);
      return <div className="anim anim--fadeOut">{stepRenderer()}</div>;
    }
    if (this.isCurrentStep(stepName) && !this.hasPreviousStep()) {
      return <div className="anim anim--fadeIn">{stepRenderer()}</div>;
    }
  }

  renderStepAccount() {
    return (
      <AccountCard
        hiddenFields={this.state.stepResults}
        onSuccess={this.advanceStep}
        tag={this.interpolateVariables(this.props.tag)}
      />
    );
  }

  renderStepLead() {
    return (
      <LeadCard
        hiddenFields={{ ...this.state.stepResults, resumeSignupLink: this.props.resumeSignupLink }}
        onLeadSuccess={this.advanceStep}
        onFacebookSuccess={this.onComplete}
        tag={this.interpolateVariables(this.props.tag)}
      />
    );
  }

  renderStepProduct() {
    const { ctaCopy, offers } = this.props;
    const productCardProps = ObjectUtil.pick(Object.keys(ProductCard.propTypes), this.props);
    const productCardUnwrappedProps = ObjectUtil.pick(Object.keys(ProductCardUnwrapped.propTypes), this.props);
    const cta = (
      <ProductForm
        copy={ctaCopy}
        hiddenFields={{
          ...this.state.stepResults,
          productId: offers?.[0].productId,
          productType: offers?.[0].productType,
          resumeSignupLink: offers?.[0].url,
        }}
        onSuccess={this.advanceStep}
      />
    );

    return <ProductCard {...productCardProps} {...productCardUnwrappedProps} cta={cta} />;
  }

  render() {
    return (
      <Fragment>
        {this.renderStep(STEPS.ACCOUNT, this.renderStepAccount)}
        {this.renderStep(STEPS.LEAD, this.renderStepLead)}
        {this.renderStep(STEPS.PRODUCT, this.renderStepProduct)}
      </Fragment>
    );
  }
}

SignupCardUnwrapped.propTypes = {
  ...ProductCard.propTypes,
  ...ProductCardUnwrapped.propTypes,
};

export const mapStateToProps = state => {
  return {
    resumeSignupLink: selectSubmittedOfferUrl(state) || {},
  };
};

export const SignupCard = decorateWith(
  withInterpolate(DOLLAR_SIGN_REGEX),
  withSagas({ watch: watchSignupCardSagas }),
  connect(
    mapStateToProps,
    { onComplete: redirectToNextStep }
  ),
  withName('SignupCard')
)(SignupCardUnwrapped);
